import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const EpicIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <path
      d="m11.843 11.153-.37 1.737H6.084l-.253 1.346h4.751l-.36 1.673H5.471l-.254 1.378h5.324l.931-4.386h2.319l-.17.816h.021c.646-.625 1.567-.975 2.541-.975 1.768 0 2.857.795 2.963 2.235l.445-2.076h2.414l-.476 2.236c.72-1.664 2.445-2.49 4.73-2.49 2.202 0 3.663.636 3.578 2.437H27.35c-.052-.54-.486-.848-1.397-.848-1.122 0-1.937.614-2.17 1.727-.233 1.112.287 1.737 1.44 1.737.868 0 1.524-.35 1.863-1.07h2.54c-.74 1.695-2.138 2.649-4.784 2.649-2.339 0-3.673-.784-3.683-2.458l-.477 2.203H18.3l.423-1.98c-.677 1.303-2.075 2.235-3.895 2.235-1.07 0-1.81-.35-2.117-.805h-.021l-.593 2.775H9.705l.466-2.213H2.158l1.609-7.883h8.076Zm3.42 3.263c-1.123 0-1.843.615-2.044 1.558-.2.942.254 1.557 1.376 1.557 1.09 0 1.81-.54 2.021-1.557.223-1.017-.264-1.558-1.354-1.558Z"
      fill={preserveColor ? '#BA122B' : undefined}
    />
    <path
      d="m22.448 10.75-.306 1.452H19.75l.307-1.451h2.392Z"
      fill={preserveColor ? '#BA122B' : undefined}
    />
  </BaseIcon>
);
